import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/tabPanel.scss';
import React, { useEffect, useRef, useState } from 'react';
import { useScrollable } from '../Scroll/usePopoverScrollable';
import { Stack } from '@front/sharedcomponents/Stack/Stack';
import { Typography } from '../Typography/Typography';
import { TypographyLevel } from '../Typography/TypographyLevel';
export const TabItem = (props) => {
    return props.children;
};
export const TabPanel = ({ children, mode = 'default', initialIndex = 0, activeIndex, headerClassName, withScroll = false, className, onTabChange }) => {
    const [internalIndex, setInternalIndex] = useState(initialIndex);
    const isControlled = activeIndex !== undefined;
    const currentIndex = isControlled ? activeIndex : internalIndex;
    const tabs = React.Children.toArray(children);
    const scrollableRef = useRef(null);
    const activeTabRef = useRef(null);
    useScrollable(scrollableRef, withScroll, 'x');
    useEffect(() => {
        if (withScroll && !isNullOrUndefined(activeTabRef.current)) {
            activeTabRef.current.scrollIntoView({ behavior: 'auto', block: 'nearest' });
        }
    }, [withScroll]);
    const handleTabClick = (index) => {
        if (!isControlled) {
            setInternalIndex(index);
        }
        onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(index);
    };
    const tabPanelHeaderClassNames = ['tab-panel-header', mode === 'stretch' ? 'stretch' : '', headerClassName];
    const tabPanelHeaderClassName = tabPanelHeaderClassNames.filter(Boolean).join(' ');
    const tabPanelClassName = ['tab-panel', className].filter(Boolean).join(' ');
    return (_jsxs("div", { className: tabPanelClassName, children: [_jsx(Stack, { ref: scrollableRef, className: "scrollable-container", style: { width: '100%' }, children: _jsx(Stack, { className: tabPanelHeaderClassName, role: "tablist", direction: "row", children: tabs.map((tab, index) => (_jsx("button", { className: `tab-panel-header-tab ${index === currentIndex ? 'selected' : ''}`, role: "tab", "aria-selected": index === currentIndex, disabled: tab.props.disabled, onClick: () => handleTabClick(index), ref: index === currentIndex ? activeTabRef : undefined, children: _jsx(Typography, { level: TypographyLevel.BodyMd, className: "tab-panel-header-tab-title", children: tab.props.title }) }, tab.props.title))) }) }), _jsx("div", { className: "tab-panel-content", role: "tabpanel", children: tabs[currentIndex] })] }));
};
